module.exports = __webpack_public_path__ + "static/fast-slider-hide-marks-c2724eb4c8ea962528e8ef53b6730fbe.png";